module.exports = __webpack_public_path__ + "img/car-5.787c7c40.jpg";